(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Scrolling-text-image"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '.cb-index-section-partner-wrap';
    const trackSelector =
      '.cb-index-section-partner__desktop-wrap.is-animated, .cb-index-section-partner__mobile-item-wrap.is-animated';

    const stripEditorAttributes = (node) => {
      const elements = [node, ...node.querySelectorAll('*')];

      elements.forEach((element) => {
        Array.from(element.attributes).forEach((attribute) => {
          if (attribute.name === 'id' || attribute.name.startsWith('data-shopify')) {
            element.removeAttribute(attribute.name);
          }
        });
      });
    };

    const createGeneratedItem = (item) => {
      const clone = item.cloneNode(true);
      clone.dataset.cbMarqueeGenerated = 'true';
      clone.setAttribute('aria-hidden', 'true');
      stripEditorAttributes(clone);
      return clone;
    };

    const fillTrack = (track) => {
      const viewport = track.parentElement;
      const viewportWidth = viewport.clientWidth;

      if (viewportWidth === 0) {
        return;
      }

      const groups = Array.from(track.children).filter((element) => {
        return (
          element.classList.contains('cb-index-section-partner__desktop-group') ||
          element.classList.contains('cb-index-section-partner__mobile-group')
        );
      });

      if (groups.length < 2) {
        return;
      }

      const firstGroup = groups[0];
      const secondGroup = groups[1];

      Array.from(firstGroup.children).forEach((item) => {
        if (item.dataset.cbMarqueeGenerated === 'true') {
          item.remove();
        }
      });

      const sourceItems = Array.from(firstGroup.children);

      if (sourceItems.length === 0) {
        return;
      }

      track.style.animation = 'none';

      let previousWidth = firstGroup.scrollWidth;
      let pass = 0;

      // 如果宽度未达到视口宽度，继续用 JS 深度补齐
      while (firstGroup.scrollWidth < viewportWidth && pass < 30) {
        const fragment = document.createDocumentFragment();

        sourceItems.forEach((item) => {
          fragment.appendChild(createGeneratedItem(item));
        });

        firstGroup.appendChild(fragment);
        pass += 1;

        if (firstGroup.scrollWidth <= previousWidth) {
          break;
        }

        previousWidth = firstGroup.scrollWidth;
      }

      const secondFragment = document.createDocumentFragment();

      Array.from(firstGroup.children).forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        stripEditorAttributes(clone);
        secondFragment.appendChild(clone);
      });

      secondGroup.replaceChildren(secondFragment);
      track.offsetHeight;
      track.style.animation = '';
    };

    const init = (scope = document) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      const roots = scope.matches?.(rootSelector) ? [scope] : Array.from(scope.querySelectorAll(rootSelector));

      roots.forEach((root) => {
        root.querySelectorAll(trackSelector).forEach(fillTrack);
      });
    };

    if (window.cbPartnerMarquee) {
      window.cbPartnerMarquee.init(document);
      return;
    }

    window.cbPartnerMarquee = { init };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => init(document));
    }

    let resizeTimer;

    window.addEventListener(
      'resize',
      () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => init(document), 150);
      },
      { passive: true }
    );

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-media-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-media-video-player')) {
    customElements.define('featured-media-video-player', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), {
            once: true,
            signal: this.controller.signal
          });
        } else {
          this.initialize();
        }
      }

      initialize() {
        if (!this.isConnected) return;
        this.card = this.querySelector('.featured-media-video__card');
        this.playButton = this.querySelector('.featured-media-video__play-btn');
        this.modal = this.querySelector('.featured-media-video__modal');
        this.closeButton = this.querySelector('.featured-media-video__modal-close');
        this.overlay = this.querySelector('.featured-media-video__modal-overlay');
        this.mediaBody = this.querySelector('.featured-media-video__modal-body');
        this.mediaTemplate = this.querySelector('template[data-video-template]');
        if (!this.card || !this.modal || !this.mediaBody || !this.mediaTemplate) return;

        const options = { signal: this.controller.signal };
        this.card.addEventListener('click', () => this.openModal(), options);
        this.closeButton?.addEventListener('click', () => this.closeModal(), options);
        this.overlay?.addEventListener('click', () => this.closeModal(), options);
        document.addEventListener('keydown', (event) => {
          if (!this.modal.classList.contains('is-open')) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            this.closeModal();
          } else if (event.key === 'Tab') {
            const elements = Array.from(this.modal.querySelectorAll(
              'button:not([disabled]), iframe, video[controls], [tabindex="0"]'
            )).filter((element) => element.getClientRects().length > 0);
            const first = elements[0];
            const last = elements[elements.length - 1];
            if (!first) {
              event.preventDefault();
              this.modal.focus();
            } else if (event.shiftKey && (document.activeElement === first || !this.modal.contains(document.activeElement))) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && (document.activeElement === last || !this.modal.contains(document.activeElement))) {
              event.preventDefault();
              first.focus();
            }
          }
        }, options);
        window.addEventListener('pagehide', () => this.closeModal(false), options);
      }

      openModal() {
        if (this.modal.classList.contains('is-open')) return;
        if (!this.mediaTemplate.content.querySelector('iframe, video')) return;

        document.querySelectorAll('featured-media-video-player').forEach((component) => {
          if (component !== this) component.closeModal(false);
        });
        this.returnFocus = this.playButton;
        this.modal.classList.add('is-open');
        this.modal.setAttribute('aria-hidden', 'false');
        this.playButton?.setAttribute('aria-expanded', 'true');
        this.mediaBody.replaceChildren(document.importNode(this.mediaTemplate.content, true));
        this.closeButton?.focus({ preventScroll: true });

        const video = this.mediaBody.querySelector('video');
        if (video) {
          const playback = video.play();
          if (playback && typeof playback.catch === 'function') {
            playback.catch(() => {
              if (video.isConnected && this.modal.classList.contains('is-open')) {
                video.controls = true;
              }
            });
          }
        }
      }

      closeModal(restoreFocus = true) {
        if (!this.modal || !this.mediaBody) return;
        const wasOpen = this.modal.classList.contains('is-open');
        this.mediaBody.querySelectorAll('video').forEach((video) => video.pause());
        this.mediaBody.replaceChildren();
        this.modal.classList.remove('is-open');
        this.modal.setAttribute('aria-hidden', 'true');
        this.playButton?.setAttribute('aria-expanded', 'false');
        if (restoreFocus && wasOpen && this.returnFocus?.isConnected) {
          this.returnFocus.focus({ preventScroll: true });
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.closeModal(false);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
